import { REGIONS_ENDPOINTS } from "../constants/api";
import { publicApiClient } from "../utils/axios.utils";

export interface Region {
    id: number;
    name: string;
}

/**
 * Region Service
 * This service handles all API calls related to regions.
 */
export const RegionService = {
    getAllRegions: async (): Promise<Region[]> => {
        const response = await publicApiClient.get(REGIONS_ENDPOINTS.GET_ALL);
        return response.data.data;
    },
};
